import { render, staticRenderFns } from "./UiDatePicker.vue?vue&type=template&id=fc94c86e&"
import script from "./UiDatePicker.vue?vue&type=script&lang=ts&"
export * from "./UiDatePicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports